import { Component } from "react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ListBanquesToPayement from "../../../models/ListBanquesToPayement";
import UploadAndDownloadService from "../../../services/uploadAndDownloadFile";

import BCService from "../../../services/BC";
import SalesService from "../../../services/SellingService";
import { TextField } from "@material-ui/core";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
class PayementTotalBillVirement extends Component {
  state = {
    codeVirement: "",
    amount: "",
    amountMax: "",
    datePayement: "",
    selectedFile: null,
    urlFile: "",
    fileName: "Ordre de virement",
  };

  constructor(props) {
    super(props);
    this.state = {
      codeVirement: "",
      amount: this.props.restToPay,
      amountMax: "",
      datePayement: "",
      selectedFile: null,
      urlFile: "",
      fileName: "Ordre de virement",
    };

    this.changeCodeVirement = this.changeCodeVirement.bind(this);
    this.changeDatePayement = this.changeDatePayement.bind(this);
    this.changeAmount = this.changeAmount.bind(this);
  }

  refreshPage() {
    window.location.reload(false);
  }
  changeCodeVirement(event) {
    this.setState({ codeVirement: event.target.value });
    console.log("codeVirement", this.state.codeVirement);
  }
  changeDatePayement(event) {
    this.setState({ datePayement: event.target.value });
    console.log("datePayement", this.state.datePayement);
  }

  changeAmount(event) {
    // var amount = event.target.value;
    // if (amount > this.state.amountMax) {
    //   this.setState({ alert_message: "error" });
    // } else {
    this.setState({ amount: event.target.value });
    // }

    // console.log("amount", this.state.amount);
  }

  onFileChangeHandler = (event) => {
    if (event.target.files[0].size > 2097152) {
      toast.info("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      this.setState({
        fileName: event.target.files[0].name,
      });
      this.setState({
        selectedFile: event.target.files[0],
        loaded: 0,
      });
    }
  };
  UploadFile = () => {
    const dataFile = new FormData();
    dataFile.append("file", this.state.selectedFile);

    // original  UploadFileService.uploadFileBill(dataFile).then((res) => {
    //   console.log("name File image", res.data["Bill"]);
    //   let name = res.data["Bill"];
    //   localStorage.setItem("fileName", name);
    //   console.log(res.statusText);
    // });
  };

  payerBill = (e) => {
    // let payement = {
    //   idBonCommande: localStorage.getItem("idBC"),
    //   numVirement: this.state.codeVirement,
    //   payementDate: this.state.datePayement,
    //   amountPayed: this.state.amount,
    //   fileName: this.state.selectedFile,
    //   nameBanque: localStorage.getItem("banqueAccount"),
    // };
    const url = window.location.pathname.split("/")[1];
    if (url === "payerBill") {
      if (this.state.codeVirement === "") {
        toast.error("Erreur : le champ  Réference valeur est vide");
      } else if (this.state.datePayement === "") {
        toast.error("Erreur : le champ  date de l'échéance est vide");
      } else if (this.state.amount === "") {
        toast.error("Erreur : le champ montant  est vide");
      } else if (localStorage.getItem("banqueAccount") == null) {
        toast.error("Erreur : le champ compte bancaire est vide");
      } else {
        let payFactureOrAvance = {
          idUser: getCurrentUserId(),

          isFactureOrBDC: 1,
          idDocument: parseInt(localStorage.getItem("idBill")),

          isAvanceOrTotalPayement: 1,

          typePayement: 3,

          echanceDate: this.state.datePayement,
          ammountPayed: this.state.amount,
          urlFile: "any",
          banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
          numVirement: this.state.codeVirement,

          // codeCheque: this.state.codePayementCheque,
        };

        if (this.state.selectedFile != null) {
          const uploadData = new FormData();
          uploadData.append("picture", this.state.selectedFile);

          UploadAndDownloadService.uploadFile(
            "/retail/uploadFile/uploadFile/Payement",
            uploadData
          )
            .then((response) => {
              if (response.data["success"]) {
                payFactureOrAvance.urlFile = response.data["success"];
                BCService.payFactureOrBDC(payFactureOrAvance)

                  .then((response) => {
                    console.log(response);
                    if (response.data["error"]) {
                      toast.error("Error : il ya un probléme");
                    } else {
                      toast.success("ajouté avec succès");

                      this.refreshPage();
                    }
                  })
                  .catch((error) => {
                    toast.error("Error : " + error);

                    this.refreshPage();
                  });
              } else {
                toast.error("Erreur : il ya un probléme au niveau de serveur");
              }
            })
            .catch(() => {
              toast.error("Erreur : il ya un probléme de connection");
            });

          e.preventDefault();
        } else {
          BCService.payFactureOrBDC(payFactureOrAvance)
            .then((response) => {
              if (response.data["error"]) {
                toast.error("Error : il ya un probléme");
              } else {
                toast.success("ajouté avec succès");

                this.refreshPage();
              }
            })
            .catch((error) => {
              toast.error("Error : il ya un probléme");

              this.refreshPage();
            });
        }
      }
    } else {
      if (this.state.codeVirement === "") {
        toast.error("Erreur : le champ  Réference valeur est vide");
      } else if (this.state.datePayement === "") {
        toast.error("Erreur : le champ  date de l'échéance est vide");
      } else if (this.state.amount === "") {
        toast.error("Erreur : le champ montant  est vide");
      } else if (localStorage.getItem("banqueAccount") == null) {
        toast.error("Erreur : le champ compte bancaire est vide");
      } else {
        let payFactureOrAvance = {
          idUser: getCurrentUserId(),

          isFactureOrBDC: 1,
          idDocument: parseInt(localStorage.getItem("idBill")),

          isAvanceOrTotalPayement: 1,

          typePayement: 3,

          echanceDate: this.state.datePayement
            .toString()
            .substring(0, this.state.datePayement.toString().lastIndexOf(".")),
          ammountPayed: this.state.amount,
          urlFile: "any",
          banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
          numVirement: this.state.codeVirement,

          // codeCheque: this.state.codePayementCheque,
        };

        if (this.state.selectedFile != null) {
          const uploadData = new FormData();
          uploadData.append("picture", this.state.selectedFile);

          UploadAndDownloadService.uploadFile(
            "/sales/uploadFileSelling/uploadFile/Payement",
            uploadData
          )
            .then((response) => {
              if (response.data["success"]) {
                payFactureOrAvance.urlFile = response.data["success"];
                SalesService.payFactureOrBDC(payFactureOrAvance)

                  .then((response) => {
                    console.log(response);
                    if (response.data["error"]) {
                      toast.error("Error : il ya un probléme");
                    } else {
                      toast.success("ajouté avec succès");

                      this.refreshPage();
                    }
                  })
                  .catch((error) => {
                    toast.error("Error : " + error);

                    this.refreshPage();
                  });
              } else {
                toast.error("Erreur : il ya un probléme au niveau de serveur");
              }
            })
            .catch(() => {
              toast.error("Erreur : il ya un probléme de connection");
            });

          e.preventDefault();
        } else {
          SalesService.payFactureOrBDC(payFactureOrAvance)
            .then((response) => {
              if (response.data["error"]) {
                toast.error("Error : il ya un probléme");
              } else {
                toast.success("ajouté avec succès");

                this.refreshPage();
              }
            })
            .catch((error) => {
              toast.error("Error : il ya un probléme");

              this.refreshPage();
            });
        }
      }
    }
  };

  render() {
    return (
      <div className="box-body">
        <ToastContainer />
        <br />
        <br />
        <div className="row">
          <div className="col-12">
            <label>Payement Virement: </label>
          </div>
        </div>
        <div className="row">
          <div class="col-md-12">
            <label>Compte bancaire</label>
            <ListBanquesToPayement type={1} />
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <label>Montant : </label>
            <input
              disabled
              class="form-control"
              // placeholder="Montant "
              name="amount"
              value={this.state.amount}
              // onChange={this.changeAmount}
            />
          </div>

          <div class="col-md-4">
            <label>Réference Valeur: </label>

            <input
              value={this.state.codeVirement}
              onChange={this.changeCodeVirement}
              class="form-control"
              placeholder="Ref.Valeur"
            />
          </div>

          <div class="col-md-4">
            <label>Date de l'échéance </label>
            <br />
            <TextField
              style={{ width: "100%" }}
              className="col-sm-12"
              variant="outlined"
              value={this.state.datePayement}
              onChange={this.changeDatePayement}
              id="datetime-local"
              type="datetime-local"
              defaultValue="date"
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
            />
          </div>
        </div>
        <div className="row">
          <div class="col-md-12">
            <div className="form-group ">
              <label for="exampleInputFile"> Ajouter le virement </label>
              <div class="custom-file">
                <input
                  type="file"
                  accept="application/pdf,.jpg, .jpeg, .png"
                  className="custom-file-input"
                  name="file"
                  id="exampleInputFile"
                  onChange={this.onFileChangeHandler}
                />
                <label class="custom-file-label" for="exampleInputFile">
                  {this.state.fileName}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <button
            type="submit"
            onClick={this.payerBill}
            className="btn btn-dark float-right"
          >
            Payer
          </button>
        </div>
      </div>
    );
  }
}
export default PayementTotalBillVirement;
